import React from 'react';
import HeaderNavMobileItem from './HeaderNavMobileItem';

const HeaderNavMobileHamburger = ({ activates }) => <HeaderNavMobileItem icon="navicon" activates={activates}>
    Menu
  </HeaderNavMobileItem>

export default HeaderNavMobileHamburger;
